import HyperMediaAPI from './hyper-media-api';

export * from './constants';
export default HyperMediaAPI;
